<script setup lang="ts">
import { AgreementInfo } from 'src/core/types/component_types/order.terms';

defineProps<{
  preInformation: boolean;
  distanceSales: boolean;
  agreementInfo: AgreementInfo;
}>();

const $emit = defineEmits(['update:preInformation', 'update:distanceSales', 'update']);

function closeDialog(dialog: 'preInformation' | 'distanceSales') {
  $emit(`update:${dialog}`, false);
}
</script>

<template>
  <div id="TermsAndAgreements">
    <q-dialog :model-value="preInformation" @update:model-value="$emit('update:preInformation', $event)" persistent>
      <q-card>
        <q-card-section>
          <div class="text-h6">📄 Ön Bilgilendirme Formu</div>
        </q-card-section>

        <q-separator />

        <q-card-section style="max-height: 50vh" class="scroll">
          <div class="form-content q-px-md">
            <section class="section q-mb-md">
              <h2 class="text-h6">1. Satıcı Bilgileri</h2>
              <q-list>
                <q-item><strong>Şirket Adı/Ünvanı: </strong> {{ agreementInfo.generalInfo.company.companyName }} </q-item>
                <q-item><strong>Adres: </strong> {{ agreementInfo.generalInfo.company.companyAddress }}</q-item>
                <q-item><strong>Telefon: </strong> {{ agreementInfo.generalInfo.company.companyPhone }}</q-item>
                <q-item><strong>Faks: </strong> {{ agreementInfo.generalInfo.company.companyFax }}</q-item>
                <q-item><strong>E-posta: </strong> {{ agreementInfo.generalInfo.company.companyEmail }}</q-item>
                <q-item><strong>İade Bildirimi için E-posta: </strong> {{ agreementInfo.generalInfo.company.companyEmail }} </q-item>
                <q-item><strong>Web Sitesi: </strong> {{ agreementInfo.generalInfo.company.companyWebsite }}</q-item>
              </q-list>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">2. Alıcı Bilgileri</h2>
              <q-list>
                <q-item><strong>Ad/Soyad: </strong> {{ agreementInfo.buyerInfo.name }}</q-item>
                <q-item
                  ><strong>Adres: </strong>
                  {{
                    `${agreementInfo.addressInfo.shippingAddress.address} ${agreementInfo.addressInfo.shippingAddress.city}/${agreementInfo.addressInfo.shippingAddress.district}`
                  }}
                </q-item>
                <q-item
                  ><strong>Telefon: </strong>
                  {{ agreementInfo.buyerInfo.telephone || agreementInfo.addressInfo.shippingAddress.telephone }}
                </q-item>
                <q-item><strong>E-posta: </strong> {{ agreementInfo.buyerInfo.email }}</q-item>
              </q-list>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">3. Ürün Bilgileri</h2>
              <p>
                Ürünlerin temel özellikleri (türü, miktarı, marka/modeli, rengi, adedi) web sitemizde yayınlanmaktadır. Kampanya düzenlenmiş ise, ilgili ürünün temel
                özelliklerini kampanya süresince inceleyebilirsiniz. Kampanya
                {{
                  new Date(new Date(agreementInfo.orderInfo.orderdate).setDate(new Date(agreementInfo.orderInfo.orderdate).getDate() + 3)).toISOString().split('T')[0] ||
                  'tarihi belirtilmemiştir'
                }}
                tarihine kadar geçerlidir.
              </p>
              <div class="scroll" style="max-width: 100%; overflow: hidden">
                <q-table :rows="agreementInfo.orderInfo.products" row-key="description" flat bordered class="q-mb-md" dense hide-pagination>
                  <template v-slot:header>
                    <q-tr>
                      <q-th>Ürün Adı</q-th>
                      <q-th>Adet</q-th>
                      <q-th>Birim Fiyatı</q-th>
                      <q-th>Ara Toplam (KDV Dahil)</q-th>
                    </q-tr>
                  </template>
                  <template v-slot:body="props">
                    <q-tr :props="props">
                      <q-td key="description" style="text-wrap: auto">{{ props.row.name }}</q-td>
                      <q-td key="quantity">{{ props.row.quantity }}</q-td>
                      <q-td key="variations">{{ props.row.price }}</q-td>
                      <q-td key="variations">
                        {{ $numberToCurrency(props.row.variations[0].priceNumber * props.row.quantity + props.row.variations[0].priceInfo.tax * props.row.quantity) }} ₺
                      </q-td>
                    </q-tr>
                  </template>
                </q-table>
              </div>
              <p><strong>Kargo Tutarı: </strong> {{ $numberToCurrency(agreementInfo.generalInfo.shippingCost) }} ₺</p>
              <p><strong>Toplam: </strong> {{ $numberToCurrency(agreementInfo.orderInfo.amount) }} ₺</p>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">4. Ödeme ve Teslimat Bilgileri</h2>
              <q-list>
                <!--              <q-item><strong>Ödeme Şekli:</strong> {{ preliminaryInfo.orderInfo.paymentMethod }}</q-item>-->
                <q-item
                  ><strong>Teslimat Adresi: </strong>
                  {{
                    `${agreementInfo.addressInfo.shippingAddress.address} ${agreementInfo.addressInfo.shippingAddress.city}/${agreementInfo.addressInfo.shippingAddress.district}`
                  }}
                </q-item>
                <q-item><strong>Teslim Edilecek Kişi: </strong> {{ agreementInfo.addressInfo.shippingAddress.namesurname }} </q-item>
                <q-item
                  ><strong>Fatura Adresi: </strong>
                  {{
                    `${agreementInfo.addressInfo.billingAddress.address} ${agreementInfo.addressInfo.billingAddress.city}/${agreementInfo.addressInfo.billingAddress.district}`
                  }}
                </q-item>
                <q-item><strong>Sipariş Tarihi: </strong> {{ agreementInfo.orderInfo.orderdate }}</q-item>
                <!--              <q-item><strong>Teslimat Tarihi: </strong> {{ preliminaryInfo.orderInfo.deliveryDate }}</q-item>-->
                <!--              <q-item><strong>Teslim Şekli: </strong> {{ preliminaryInfo.orderInfo.deliveryMethod }}</q-item>-->
                <!--              <q-item-->
                <!--                ><strong>Banka Havalesi/EFT: </strong> Ödemeler, {{ preliminaryInfo.bankAccounts.join(', ') }}-->
                <!--                bankası hesaplarımızdan (TL) herhangi birine yapılabilir.-->
                <!--              </q-item>-->
                <q-item
                  ><strong>Kredi Kartı: </strong> Her türlü kredi kartınızla online tek ödeme ya da taksit imkânlarından yararlanabilirsiniz. Sipariş sonunda kredi
                  kartınızdan tutar çekim işlemi gerçekleşecektir.
                </q-item>
              </q-list>
              <p>Ürün sevkiyat masrafı olan kargo ücreti ALICI tarafından ödenecektir.</p>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">5. Cayma Hakkı</h2>
              <q-list>
                <q-item
                  >ALICI, ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa teslim tarihinden itibaren 14 (on dört) gün içerisinde, SATICI’ya yazılı bildirimde
                  bulunarak (iadeli taahhütlü posta, faks veya e-posta: {{ agreementInfo.generalInfo.company.companyEmail }}) hiçbir gerekçe göstermeksizin ve cezai
                  sorumluluk üstlenmeksizin sözleşmeden cayma hakkını kullanabilir. Cayma hakkı masrafları SATICI’ya aittir.
                </q-item>
                <q-item
                  >Cayma hakkının kullanılması için ürün kullanılmamış, ambalajı açılmamış ve hasarsız olmalıdır. Ürünle birlikte fatura ve iade formu teslim edilmelidir.
                </q-item>
                <q-item
                  >SATICI, cayma bildiriminden itibaren 10 gün içinde toplam bedeli ve ALICI’yı borç altına sokan belgeleri iade eder; 20 gün içinde ürünü geri alır.
                </q-item>
                <q-item
                  >ALICI’nın kusurundan kaynaklanan değer azalması durumunda, ALICI kusuru oranında SATICI’nın zararlarını tazmin eder. Ancak, cayma hakkı süresi içinde
                  ürünün usulüne uygun kullanımı nedeniyle oluşan değişikliklerden ALICI sorumlu değildir.
                </q-item>
                <q-item>Kampanya indirimleri, cayma nedeniyle limit altına düşerse iptal edilir.</q-item>
              </q-list>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">6. Cayma Hakkı Kullanılamayacak Ürünler</h2>
              <q-list>
                <q-item
                  >ALICI’nın özel istekleri doğrultusunda kişiselleştirilmiş (örneğin, üzerine isim veya özel tasarım işlenmiş) takı ve aksesuarlar, iade edilmeye uygun
                  değildir. Ambalajı açılmış, kullanılmış veya hasar görmüş ürünler de iade edilemez.
                </q-item>
              </q-list>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">7. Şikayet ve İtirazlar</h2>
              <q-list>
                <q-item
                  >Uyuşmazlıklarda, ALICI’nın yerleşim yeri veya işlem yerindeki tüketici hakem heyetleri veya tüketici mahkemeleri yetkilidir. 2025 için geçerli parasal
                  sınırları resmi kaynaklardan doğrulayınız.
                </q-item>
                <q-item>Şikayet ve itirazlar için SATICI’ya şu iletişim bilgileri üzerinden ulaşabilirsiniz:</q-item>
                <q-item class="q-pl-md">
                  <q-list>
                    <q-item><strong>E-posta: </strong> {{ agreementInfo.generalInfo.company.companyEmail }}</q-item>
                    <q-item><strong>Telefon: </strong> {{ agreementInfo.generalInfo.company.companyPhone }}</q-item>
                    <q-item><strong>Adres: </strong> {{ agreementInfo.generalInfo.company.companyAddress }}</q-item>
                  </q-list>
                </q-item>
              </q-list>
            </section>

            <section class="section q-mb-md">
              <h2 class="text-h6">8. Sözleşmenin Kabulü</h2>
              <q-list>
                <q-item
                  >ALICI, işbu Ön Bilgilendirme Formu’nu elektronik ortamda onaylayarak, sipariş konusu ürünlerin satış ve teslim şartlarını, ödeme ve teslimat
                  bilgilerini, cayma hakkı ve diğer yükümlülükleri kabul ettiğini beyan eder.
                </q-item>
              </q-list>
            </section>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn flat label="Reddet" color="primary" @click="closeDialog('preInformation')" />
          <q-btn flat label="Kabul Ediyorum" color="primary" @click="closeDialog('preInformation')" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog :model-value="distanceSales" @update:model-value="$emit('update:distanceSales', $event)" persistent>
      <q-card style="width: 100%">
        <q-card-section>
          <div class="text-h6">📝 Mesafeli Satış Sözleşmesi</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pa-md">
          <q-scroll-area style="height: 60vh" class="q-mb-md">
            <div class="agreement-content q-pa-md">
              <section class="section q-mb-md">
                <h2 class="text-h6">1. Taraflar</h2>
                <p>İşbu Sözleşme aşağıdaki taraflar arasında aşağıda belirtilen hüküm ve şartlar çerçevesinde akdedilmiştir.</p>
                <p><strong>A. ALICI </strong> (Bundan sonra 'ALICI' olarak anılacaktır):</p>
                <ul>
                  <li>Ad-Soyad: {{ agreementInfo.buyerInfo.name }}</li>
                  <li>
                    Adres:
                    {{
                      `${agreementInfo.addressInfo.shippingAddress.address} ${agreementInfo.addressInfo.shippingAddress.city}/${agreementInfo.addressInfo.shippingAddress.district}`
                    }}
                  </li>
                  <li>
                    Telefon:
                    {{ agreementInfo.buyerInfo.telephone || agreementInfo.addressInfo.shippingAddress.telephone }}
                  </li>
                  <li>E-posta: {{ agreementInfo.buyerInfo.email }}</li>
                </ul>
                <p><strong>B. SATICI </strong> (Bundan sonra 'SATICI' olarak anılacaktır):</p>
                <ul>
                  <li>Ünvan: {{ agreementInfo.generalInfo.company.companyName }}</li>
                  <li>Adres: {{ agreementInfo.generalInfo.company.companyAddress }}</li>
                  <li>Telefon: {{ agreementInfo.generalInfo.company.companyPhone }}</li>
                  <li>Faks: {{ agreementInfo.generalInfo.company.companyFax }}</li>
                  <li>E-posta: {{ agreementInfo.generalInfo.company.companyEmail }}</li>
                </ul>
                <p>
                  ALICI, işbu sözleşmeyi kabul etmekle, sipariş konusu bedeli ve varsa kargo ücreti, vergi gibi ek ücretleri ödeme yükümlülüğü altına gireceğini ve bu
                  konuda bilgilendirildiğini peşinen kabul eder.
                </p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">2. Tanımlar</h2>
                <p>İşbu sözleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki açıklamaları ifade eder:</p>
                <ul>
                  <li><strong>BAKAN: </strong> Gümrük ve Ticaret Bakanı’nı,</li>
                  <li><strong>BAKANLIK: </strong> Gümrük ve Ticaret Bakanlığı’nı,</li>
                  <li><strong>KANUN: </strong> 6502 sayılı Tüketicinin Korunması Hakkında Kanun’u,</li>
                  <li><strong>YÖNETMELİK: </strong> Mesafeli Sözleşmeler Yönetmeliği’ni (RG: 27.11.2014/29188),</li>
                  <li>
                    <strong>HİZMET: </strong> Bir ücret veya menfaat karşılığında yapılan ya da yapılması taahhüt edilen mal sağlama dışındaki her türlü tüketici
                    işleminin konusunu,
                  </li>
                  <li>
                    <strong>SATICI: </strong> Ticari veya mesleki faaliyetleri kapsamında tüketiciye mal sunan veya mal sunan adına veya hesabına hareket eden şirketi,
                  </li>
                  <li><strong>ALICI: </strong> Bir mal veya hizmeti ticari veya mesleki olmayan amaçlarla edinen, kullanan veya yararlanan gerçek ya da tüzel kişiyi,</li>
                  <li><strong>SİTE: </strong> SATICI’ya ait internet sitesini ({{ agreementInfo.generalInfo.company.companyWebsite }}),</li>
                  <li><strong>SİPARİŞ VEREN: </strong> Bir mal veya hizmeti SATICI’ya ait internet sitesi üzerinden talep eden gerçek ya da tüzel kişiyi,</li>
                  <li><strong>TARAFLAR: </strong> SATICI ve ALICI’yı,</li>
                  <li><strong>SÖZLEŞME: </strong> SATICI ve ALICI arasında akdedilen işbu sözleşmeyi,</li>
                  <li>
                    <strong>MAL: </strong> Alışverişe konu olan taşınır eşyayı ve elektronik ortamda kullanılmak üzere hazırlanan yazılım, ses, görüntü ve benzeri gayri
                    maddi malları ifade eder.
                  </li>
                </ul>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">3. Konu</h2>
                <p>
                  İşbu Sözleşme, ALICI’nın, SATICI’ya ait internet sitesi üzerinden elektronik ortamda siparişini verdiği ürünlerin satışı ve teslimi ile ilgili olarak
                  6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmelere Dair Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerini
                  düzenler.
                </p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">4. Sözleşme Konusu Ürün/Ürünler Bilgileri</h2>
                <p>
                  Malın/Ürünlerin/Hizmetin temel özellikleri (türü, miktarı, marka/modeli, rengi, adedi) SATICI’ya ait internet sitesinde yayınlanmaktadır. Kampanya
                  düzenlenmiş ise, ilgili ürünün temel özelliklerini kampanya süresince inceleyebilirsiniz. Kampanya
                  {{
                    new Date(new Date(agreementInfo.orderInfo.orderdate).setDate(new Date(agreementInfo.orderInfo.orderdate).getDate() + 3))
                      .toISOString()
                      .split('T')[0] || 'tarihi belirtilmemiştir'
                  }}
                  tarihine kadar geçerlidir.
                </p>
                <div class="scroll" style="max-width: 100%; overflow: hidden">
                  <q-table :rows="agreementInfo.orderInfo.products" row-key="description" flat bordered class="q-mb-md" dense hide-pagination>
                    <template v-slot:header>
                      <q-tr>
                        <q-th>Ürün Adı</q-th>
                        <q-th>Adet</q-th>
                        <q-th>Birim Fiyatı</q-th>
                        <q-th>Ara Toplam (KDV Dahil)</q-th>
                      </q-tr>
                    </template>
                    <template v-slot:body="props">
                      <q-tr :props="props">
                        <q-td key="description" style="text-wrap: auto">{{ props.row.name }}</q-td>
                        <q-td key="quantity">{{ props.row.quantity }}</q-td>
                        <q-td key="variations">{{ props.row.price }}</q-td>
                        <q-td key="variations">
                          {{ $numberToCurrency(props.row.variations[0].priceNumber * props.row.quantity + props.row.variations[0].priceInfo.tax * props.row.quantity) }} ₺
                        </q-td>
                      </q-tr>
                    </template>
                  </q-table>
                </div>
                <p><strong>Kargo Tutarı: </strong> {{ $numberToCurrency(agreementInfo.generalInfo.shippingCost) }} ₺</p>
                <p><strong>Toplam: </strong> {{ $numberToCurrency(agreementInfo.orderInfo.amount) }} ₺</p>
                <!--                <p><strong>Ödeme Şekli ve Planı: </strong> {{ agreementInfo.orderInfo.paymentMethod }}</p>-->
                <p>
                  <strong>Teslimat Adresi: </strong>
                  {{
                    `${agreementInfo.addressInfo.shippingAddress.address} ${agreementInfo.addressInfo.shippingAddress.city}/${agreementInfo.addressInfo.shippingAddress.district}`
                  }}
                </p>
                <p><strong>Teslim Edilecek Kişi: </strong> {{ agreementInfo.addressInfo.shippingAddress.namesurname }}</p>
                <p>
                  <strong>Fatura Adresi: </strong>
                  {{
                    `${agreementInfo.addressInfo.billingAddress.address} ${agreementInfo.addressInfo.billingAddress.city}/${agreementInfo.addressInfo.billingAddress.district}`
                  }}
                </p>
                <p><strong>Sipariş Tarihi: </strong> {{ agreementInfo.orderInfo.orderdate }}</p>
                <!--                <p><strong>Teslimat Tarihi: </strong> {{ agreementInfo.orderInfo.deliveryDate }}</p>-->
                <!--                <p><strong>Teslim Şekli: </strong> {{ agreementInfo.orderInfo.deliveryMethod }}</p>-->
                <p>Ürün sevkiyat masrafı olan kargo ücreti ALICI tarafından ödenecektir.</p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">5. Fatura Bilgileri</h2>
                <ul>
                  <li>Ad/Soyad/Ünvan: {{ agreementInfo.buyerInfo.name }}</li>
                  <li>
                    Adres:
                    {{
                      `${agreementInfo.addressInfo.billingAddress.address} ${agreementInfo.addressInfo.billingAddress.city}/${agreementInfo.addressInfo.billingAddress.district}`
                    }}
                  </li>
                  <li>
                    Telefon:
                    {{ agreementInfo.buyerInfo.telephone || agreementInfo.addressInfo.shippingAddress.telephone }}
                  </li>
                  <li>E-posta/Kullanıcı Adı: {{ agreementInfo.buyerInfo.email }}/{{ agreementInfo.buyerInfo.name }}</li>
                </ul>
                <p>Fatura, sipariş teslimatı sırasında fatura adresine sipariş ile birlikte teslim edilecektir.</p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">6. Genel Hükümler</h2>
                <q-list numbered>
                  <q-item
                    >ALICI, SATICI’ya ait internet sitesinde ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup bilgi sahibi
                    olduğunu ve elektronik ortamda gerekli teyidi verdiğini kabul eder.
                  </q-item>
                  <q-item
                    >Sözleşme konusu ürün, 30 günlük yasal süreyi aşmamak kaydıyla, ALICI’nın yerleşim yeri uzaklığına bağlı olarak internet sitesinde belirtilen süre
                    içinde ALICI veya ALICI’nın gösterdiği adresteki kişi/kuruluşa teslim edilir. Teslimatın yapılamaması durumunda, ALICI sözleşmeyi feshetme hakkına
                    sahiptir.
                  </q-item>
                  <q-item
                    >SATICI, ürünü eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleriyle teslim etmeyi, yasal mevzuata uygun şekilde hizmet
                    kalitesini koruyarak ifa etmeyi taahhüt eder.
                  </q-item>
                  <q-item
                    >SATICI, ifa yükümlülüğünün süresi dolmadan ALICI’yı bilgilendirerek ve onayını alarak eşit kalite ve fiyatta farklı bir ürün tedarik edebilir.
                  </q-item>
                  <q-item
                    >SATICI, ürün veya hizmetin yerine getirilmesinin imkânsızlaşması halinde, durumu 3 gün içinde ALICI’ya bildirir ve 14 gün içinde toplam bedeli iade
                    eder.
                  </q-item>
                  <q-item
                    >ALICI, sözleşme konusu ürün bedelinin ödenmemesi veya banka kayıtlarında iptal edilmesi halinde, SATICI’nın teslim yükümlülüğünün sona ereceğini
                    kabul eder.
                  </q-item>
                  <q-item
                    >Ürün tesliminden sonra ALICI’ya ait kredi kartının yetkisiz kişilerce kullanılması nedeniyle bedelin ödenmemesi durumunda, ALICI ürünü 3 gün içinde
                    SATICI’ya iade eder.
                  </q-item>
                  <q-item
                    >SATICI, mücbir sebepler nedeniyle ürünü süresi içinde teslim edemezse, durumu ALICI’ya bildirir. ALICI, siparişin iptalini, ürünün emsaliyle
                    değiştirilmesini veya teslimat süresinin ertelenmesini talep edebilir.
                  </q-item>
                  <q-item>SATICI, ALICI’nın iletişim bilgileri üzerinden pazarlama ve bildirim amaçlı iletişim kurma hakkına sahiptir. </q-item>
                  <q-item
                    >ALICI, ürünü teslim almadan önce muayene eder; hasarlı veya ayıplı ürünleri teslim almaz. Teslim alınan ürünün hasarsız olduğu kabul edilir.
                  </q-item>
                  <q-item
                    >ALICI ile siparişte kullanılan kredi kartı hamilinin farklı olması durumunda, SATICI ek belgeler talep edebilir ve siparişi dondurma veya iptal etme
                    hakkına sahiptir.
                  </q-item>
                  <q-item>ALICI, siteye üye olurken verdiği bilgilerin doğruluğunu taahhüt eder ve aksi halde SATICI’nın zararlarını tazmin eder. </q-item>
                  <q-item>ALICI, siteyi yasalara uygun şekilde kullanmayı taahhüt eder.</q-item>
                  <q-item>SATICI’nın sitesinde yer alan üçüncü taraf linkler, herhangi bir garanti taşımaz.</q-item>
                  <q-item>Sözleşme maddelerini ihlal eden ALICI, hukuki ve cezai sorumlulukları üstlenir.</q-item>
                </q-list>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">7. Cayma Hakkı</h2>
                <p>
                  ALICI, ürünün teslim tarihinden itibaren 14 gün içinde, SATICI’ya bildirmek şartıyla sözleşmeden cayma hakkını kullanabilir. Cayma hakkı masrafları
                  SATICI’ya aittir. ALICI, bu konuda bilgilendirildiğini kabul eder.
                </p>
                <p>
                  Cayma hakkının kullanılması için 14 günlük süre içinde SATICI’ya iadeli taahhütlü posta, faks veya e-posta ({{
                    agreementInfo.generalInfo.company.companyEmail
                  }}) ile bildirimde bulunulmalı ve ürün kullanılmamış olmalıdır. Şu adımlar izlenmelidir:
                </p>
                <q-list numbered>
                  <q-item>Ürünün faturası (kurumsal faturalar için iade faturası ile birlikte) iade edilmelidir. </q-item>
                  <q-item>İade formu doldurulmalıdır.</q-item>
                  <q-item>Ürün, kutusu, ambalajı ve varsa standart aksesuarlarıyla eksiksiz ve hasarsız teslim edilmelidir. </q-item>
                  <q-item
                    >SATICI, cayma bildiriminden itibaren 10 gün içinde bedeli ve ALICI’yı borç altına sokan belgeleri iade eder; 20 gün içinde ürünü geri alır.
                  </q-item>
                  <q-item>Malın değerinde ALICI kusurundan kaynaklanan azalma varsa, ALICI zararı tazmin eder.</q-item>
                  <q-item>Kampanya indirimleri, cayma nedeniyle limit altına düşerse iptal edilir.</q-item>
                </q-list>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">8. Cayma Hakkı Kullanılamayacak Ürünler</h2>
                <p>
                  ALICI’nın özel istekleri doğrultusunda kişiselleştirilmiş (örneğin, üzerine isim veya özel tasarım işlenmiş) takı ve aksesuarlar, iade edilmeye uygun
                  değildir. Ambalajı açılmış, kullanılmış veya hasar görmüş ürünler de iade edilemez.
                </p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">9. Temerrüt Hali ve Hukuki Sonuçları</h2>
                <p>
                  ALICI, kredi kartı ile ödeme yaptığı durumda temerrüde düşerse, banka ile arasındaki sözleşme çerçevesinde faiz öder ve bankaya karşı sorumludur. ALICI,
                  borcun gecikmeli ifasından dolayı SATICI’nın zararlarını tazmin etmeyi kabul eder.
                </p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">10. Yetkili Mahkeme</h2>
                <p>
                  Uyuşmazlıklarda, tüketicinin yerleşim yeri veya işlem yerindeki tüketici hakem heyetleri veya mahkemeler yetkilidir. 2025 için geçerli parasal sınırları
                  resmi kaynaklardan doğrulayınız.
                </p>
              </section>

              <section class="section q-mb-md">
                <h2 class="text-h6">11. Yürürlük</h2>
                <p>
                  ALICI, siparişe ait ödemeyi gerçekleştirdiğinde işbu sözleşmenin tüm şartlarını kabul etmiş sayılır. SATICI, sipariş öncesinde sözleşmenin ALICI
                  tarafından okunup onaylandığına dair gerekli yazılımsal düzenlemeleri yapar.
                </p>
                <p>ALICI, işbu sözleşmeyi elektronik ortamda onaylayarak kabul eder.</p>
              </section>
            </div>
          </q-scroll-area>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn flat label="Reddet" color="primary" @click="closeDialog('distanceSales')" />
          <q-btn flat label="Kabul Ediyorum" color="primary" @click="closeDialog('distanceSales')" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<style scoped>
#TermsAndAgreements::v-global(.q-item) {
  min-height: auto !important;
}
</style>
